import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import './BrandOnboardingHeader.scss';

import { openAuthModal } from '../../Actions/UIActions';
import { getBrandId } from '../../Helpers/user_helpers';

import icons from '../../static/icons';

const BrandOnboardingHeader = props => {
  const { user, onboarding } = props;
  const shopmyLogo = icons.brand.full_logo;
  const shouldShowLogin = !getBrandId(user) && !onboarding.brand?.id;

  return (
    <div className='brand-onboarding-header-outer'>
      <div className='brand-onboarding-header-inner'>
        <a className='brand-onboarding-header-logo' href='https://shopmy.us/home' rel='noopener noreferrer'>
          <img src={shopmyLogo} alt='Logo' />
        </a>

        <div></div>

        <div>
          {shouldShowLogin ? (
            <>
              <Link className='nav-tab btn login show-on-large' to='/home?auth=login'>
                Log in
              </Link>
              <Link className='nav-tab btn apply' to='/home'>
                Home
              </Link>
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
};

BrandOnboardingHeader.propTypes = {
  openAuthModal: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  user: state.user,
  onboarding: state.onboarding
});

export default connect(mapStateToProps, {
  openAuthModal
})(BrandOnboardingHeader);
